<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KFAAlF/media/FC-9781398424050.jpg?1684514560786" alt="This image is the cover for the book Two Worlds Collide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Two Worlds Collide
      </h1>
      <p class="bookDescription body article font2">
        <p>The story is told through the words of the author’s dad, John Shirley, a Sub-lieutenant in the Royal Navy on board the Alnwick Castle; and Herbert Lochner, a mechanical engineer on the submarine U425. <br/>They fought separate wars, but were brought together in one dramatic and tragic incident that changed their lives forever. <br/>Find yourself immersed in life aboard a Royal Navy minesweeper on the River Thames and an Arctic convoy Royal Navy corvette. Experience life as a German submariner, below the waves in a U-boat. Immerse yourself in the emotions of both combatants, their humour and their appreciation of the beauty of the Arctic Ocean. <br/>This account is richly illustrated by John Shirley, with original water colours, painted from memory and based on sketches made at the time. <br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Shirley
      </h2>
      
      <p class="authorDescription body article">Patrick Shirley, a new author, is the youngest son of John Shirley, who wrote and illustrated the main account. Patrick’s mother, Alice Shirley, wanted his father’s richly illustrated account to be shared with the general public alongside the account of the German submariner Herbert Lochner who was saved by the Royal Navy ship Alnwick Castle. Patrick wanted this to be a tribute to the bravery of both sides in one of the most inhospitable marine environments to fight a war. For this reason, he wanted both accounts to be published together. To survive the Arctic war was a blessing and for that both families are truly thankful. Patrick was also inspired to study Geography by his father at Lincoln Christ’s Hospital School and he has a successful career in IT consultancy. He is happily married with two beautiful daughters.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cdef3a9c